<template>
    <site-img
        v-if="list && list.length > 0"
        class="md-featured-area layout5 mg-bg"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            'background-color': bgType == 'color' ? bgColor : null
        }"
    >
        <div
            class="featured-area-bg-mask"
            v-if="bgType == 'img' && maskOption.showMask"
            :style="{
                background: maskBackground,
                opacity: maskOpacity
            }"
        ></div>
        <div
            class="featured-area-container"
            :class="{ 'f-col': !isMobileSize }"
        >
            <site-title
                class="featured-area-title"
                :class="{ 'f-col': isMobileSize }"
                :title="title"
                v-animated="textAnimation"
            />

            <div
                v-if="!isMobileSize"
                class="featured-area-div"
                :class="{ noPaddingBtm: list.length % 3 == 1 }"
            >
                <a
                    class="featured-area-item"
                    v-for="(item, index) in list"
                    :key="item.url + index"
                    :href="item.url"
                    rel="noopener noreferrer"
                >
                    <img-box
                        v-if="item?.backPic"
                        class="featured-area-item-preview"
                        :src="item?.backPic"
                        dir="height"
                    />
                    <div v-else class="default-wrap">
                        <site-img
                            :src="defaultImgSrc"
                            dir="width"
                        /> 
                    </div>
                    <div
                        class="featured-area-item-img-mask"
                        :style="{
                            backgroundColor: maskOption.maskColor1
                        }"
                    ></div>
                    <div class="featured-area-item-bottom">
                        <site-title
                            class="featured-area-item-sub-title"
                            :size="24"
                            :mbSize="20"
                            :title="$ft.first(item.name)"
                            align="center"
                        />
                        <div
                            class="featured-area-item-tag-wrap"
                            v-if="item?.tagList?.length > 0"
                        >
                            <span v-for="tag in item.tagList" :key="tag">
                                {{ tag }}
                            </span>
                        </div>
                    </div>
                </a>
            </div>

            <swiper
                v-else
                class="featured-area-div"
                :class="{ noPaddingBtm: list.length == 1 }"
                v-bind="swiperOptions"
            >
                <slide v-for="(item, index) in list" :key="item.url + index">
                    <a
                        class="featured-area-item"
                        :href="item.url"
                        rel="noopener noreferrer"
                    >
                        <img-box
                            v-if="item?.backPic"
                            class="featured-area-item-preview"
                            :src="item?.backPic"
                            dir="height"
                        />
                        <div v-else class="default-wrap">
                            <site-img
                                :src="defaultImgSrc"
                                dir="width"
                            /> 
                        </div>
                        <div
                            class="featured-area-item-img-mask"
                            :style="{
                                backgroundColor: maskOption.maskColor1
                            }"
                        ></div>
                        <div class="featured-area-item-bottom">
                            <site-title
                                class="featured-area-item-sub-title"
                                :size="24"
                                :mbSize="20"
                                :title="$ft.first(item.name)"
                                align="center"
                            />
                            <div
                                class="featured-area-item-tag-wrap"
                                v-if="item?.tagList?.length > 0"
                            >
                                <span v-for="tag in item.tagList" :key="tag">
                                    {{ tag }}
                                </span>
                            </div>
                        </div>
                    </a>
                </slide>
            </swiper>
        </div>
    </site-img>
</template>

<script>
import common from '../index.js';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
import { generateLinearGradient, getColorAlpha } from '@/common/utils/handle-color';
export default {
    mixins: [common],
    components: {
        Swiper,
        Slide: SwiperSlide
    },
    computed: {
        swiperOptions() {
            if (!this.isMobileSize) {
                return; 
            }
            const obj = {
                speed: 1000,
                spaceBetween: 15,
                slidesPerView: 'auto',
                loop: false
            };
            return fixSwiperOptions(obj);
        },
        maskBackground() {
            return generateLinearGradient(this.maskOption.maskColor, [0.5, 1])
        },
        maskOpacity()  {
            return getColorAlpha(this.maskOption.maskColor)
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-featured-area.layout5 {
    box-sizing: border-box;
    position: relative;

    .featured-area-bg-mask {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
    }

    .featured-area-container {
        position: relative;
        z-index: 2;
    }

    .featured-area-title {
        margin-bottom: 40px;
        @include media-600 {
            margin-bottom: 20px;
        }
    }

    .featured-area-div {
        display: flex;
        flex-wrap: wrap;
        gap: 30px;
        padding-bottom: 200px;
        &.noPaddingBtm {
            padding-bottom: 0;
        }

        .featured-area-item {
            display: block;
            width: calc((100% - 60px) / 3);
            aspect-ratio: 1;
            position: relative;
            overflow: hidden;

            &:nth-child(3n - 1) {
                top: 200px;
            }

            .featured-area-item-preview {
                width: 100%;
                height: 100%;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;
                }
            }
            .default-wrap {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(218, 218, 218, 0.2);
                img {
                    width: 64px;
                    height: 56px;
                    object-fit: contain;
                    opacity: 0.3;
                }
                @include media-600 {
                    img {
                        width: 50px;
                        height: 44px;
                    }
                }
            }
            .featured-area-item-img-mask {
                position: absolute;
                z-index: 10;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
            }
            .featured-area-item-bottom {
                width: 100%;
                padding: 30px 20px;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 20;
                cursor: default;
                @include media-600 {
                    padding: 20px;
                }
                .featured-area-item-sub-title {
                    font-family: var(--font-medium);
                    color: #fff;
                    font-weight: 400;
                    line-height: 36px;
                    transition: all 0.3s ease;
                    @include ellipsis;
                    @include media-600 {
                        line-height: 30px;
                    }
                }
                .featured-area-item-tag-wrap {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    row-gap: 10px;
                    padding-top: 30px;
                    opacity: 0;
                    transition: all 0.3s ease;
                    position: absolute;
                    > span {
                        display: block;
                        font-size: 14px;
                        line-height: 17px;
                        font-weight: 400;
                        color: #fff;
                    }
                }
            }
            &:hover {
                .featured-area-item-preview {
                    .img-content {
                        img {
                            transform: scale(1.1);
                        }
                    }
                }
                .featured-area-item-bottom {
                    .featured-area-item-sub-title {
                        padding-bottom: 30px;
                        border-bottom: 1px solid rgba(218, 218, 218, 0.5);
                    }
                    .featured-area-item-tag-wrap {
                        opacity: 1;
                        position: static;
                    }
                }
            }
        }

        @include media-600 {
            padding-bottom: 40px;
            display: block;

            .swiper-slide {
                width: 320px;
                height: 320px;
                &:first-child {
                    margin-left: 15px;
                }

                &:nth-child(2n) {
                    position: relative;
                    top: 40px;
                }

                .featured-area-item {
                    width: 100%;
                    height: 100%;

                    .featured-area-item-bottom {
                        .featured-area-item-tag-wrap {
                            margin-top: 30px;
                            border-top: 1px solid rgba(218, 218, 218, 0.5);
                            opacity: 1;
                            position: static;
                        }
                    }
                    &:hover {
                        .featured-area-item-sub-title {
                            padding-bottom: 0;
                            border-bottom: none;
                        }
                    }
                }
            }

            &.noPaddingBtm {
                .swiper-wrapper {
                    justify-content: center;
                }
                .swiper-slide {
                    &:first-child {
                        margin-left: 0;
                        margin-right: 0 !important;
                    }
                }
            }
        }
    }
}
</style>
